import { compareFirmwareVersions } from "./compareFirmwareVersions";
import { isReliableKeyboardFirmwareVersion } from "./connectCardFirmwareVersion";
import { getFirmwareFileUrl } from "./firmwareFileUrl";

export function getFirmwareKeyFromDevice(equipmentData: any): string {
  // 无设备信息或未识别型号：不映射到任意型号目录，避免误拉 X87 等固件
  if (!equipmentData) return "";

  const vendorId = Number(equipmentData?.vendorId);
  const productId = Number(equipmentData?.productId);
  const productName = String(equipmentData?.productName || "");
  const keyboardType = String(equipmentData?.keyboardType || "");
  const displayname = String(equipmentData?.displayname ?? "").trim();
  /** 分裂空格 68EVO → es68evo；Full → es68evo(full)（USB3 驱动仍用 es68） */
  const isEs68EvoSplit = keyboardType === "68EVO" || displayname === "ES68 EVO";

  if (vendorId === 0x1ca6 && productId === 0x1c0a && productName === "X87") {
    return "x87he";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c0c &&
    (productName === "DEEP80 MAX" || /\bDEEP80\s*MAX\b/i.test(productName))
  ) {
    return "deep80max";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c3d &&
    (productName === "DK80" || /\bDK80\b/i.test(productName))
  ) {
    return "DK80";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c14 &&
    productName === "DEEP68 PRO"
  ) {
    return "deep68pro";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c12 &&
    productName === "EWEADN-DK68"
  ) {
    return "dk68";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c2b &&
    productName === "EWEADN-DK68 Star"
  ) {
    return "DK68 Star";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c2b &&
    productName === "EWEADN-DK63 Star"
  ) {
    return "DK63 Star";
  } else if (
    vendorId === 0x1ca6 &&
    (productId === 0x1c4d || productId === 0x1c49) &&
    (productName === "EWEADN-DK63V2" ||
      /\bDK63\s*V2\b/i.test(productName) ||
      displayname === "DK63 V2")
  ) {
    return "DK63 V2";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c3c &&
    (productName === "DK68 V2" || /\bDK68\s*V2\b/i.test(productName))
  ) {
    return "DK68 V2";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c2c &&
    /\bDK68\s*PRO\b/i.test(productName)
  ) {
    return "DK68-Pro";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c23 &&
    /\bDK68\s*PRO\b/i.test(productName)
  ) {
    return "DK68 Pro";
  } else if (vendorId === 0x1ca6 && productId === 0x1c2f) {
    return "es68evo";
  } else if (
    displayname === "ES68 EVO (Full)" ||
    (vendorId === 0x1ca6 && productId === 0x1c4c)
  ) {
    return "es68evo(full)";
  } else if (vendorId === 0x1a86 && productId === 0xfe81) {
    if (displayname === "ES68 EVO (Full)") return "es68evo(full)";
    return isEs68EvoSplit ? "es68evo" : "es68";
  } else if (vendorId === 0x1ca6 && productId === 0x1c24) {
    return "es68";
  } else if (vendorId === 0x1ca6 && productId === 0x1c50) {
    return "es68-luotianyi";
  } else if (vendorId === 0x1ca6 && productId === 0x1c4a) {
    return "es68lite";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c37 &&
    (/\bMETAWAY\s*Y75\b/i.test(productName) ||
      /\bMETAWAY\s*Y75\b/i.test(String(equipmentData?.displayname || "")))
  ) {
    return "metaway75";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c45 &&
    (/\bEXXGAMMA75\b/i.test(productName) ||
      displayname === "Gamma75 Ultra" ||
      keyboardType === "gamma75")
  ) {
    return "gamma75ultra";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c4e &&
    (/\bEXXGAMMA75\b/i.test(productName) ||
      displayname === "Gamma75 Pro" ||
      keyboardType === "gamma75")
  ) {
    return "gamma75pro";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c51 &&
    (/\bEXXGAMMA75\b/i.test(productName) ||
      displayname === "Gamma75 Pro Evo" ||
      keyboardType === "gamma75")
  ) {
    return "gamma75proEvo";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c37 &&
    (/\bEXXGAMMA75\b/i.test(productName) ||
      displayname === "Gamma75" ||
      keyboardType === "gamma75")
  ) {
    return "gamma75";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x1c2d &&
    (/\bX75\s*ULTRA\b/i.test(productName) ||
      displayname === "X75 Ultra" ||
      /\bX75\s*Ultra\b/i.test(displayname))
  ) {
    return "x75Ultra";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x2708 &&
    (/\bDK75\b/i.test(productName) || keyboardType === "dk75e")
  ) {
    return "dk75e";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x2709 &&
    (/\bZE75\b/i.test(productName) ||
      /\bDK75\b/i.test(productName) ||
      keyboardType === "dk75pro")
  ) {
    return "dk75pro";
  } else if (
    vendorId === 0x1ca6 &&
    productId === 0x270a &&
    (/\bDK75\b/i.test(productName) || keyboardType === "dk75")
  ) {
    return "dk75";
  } else if (
    ((vendorId === 0x258a && productId === 0x010c) ||
      (vendorId === 0x3554 && productId === 0xfa09)) &&
    keyboardType === "m75"
  ) {
    return "m75";
  } else if (
    ((vendorId === 0x258a && productId === 0x010c) ||
      (vendorId === 0x3554 && productId === 0xfa09)) &&
    keyboardType === "x75v2"
  ) {
    return "x75v2";
  }
  if (vendorId === 0x05ac && productId === 0x024f) {
    return "v80";
  }
  console.log("设备名称：未配置在线固件映射（不拉取默认型号固件）");
  return "";
}

/**
 * Windows 升级程序包路径（与服务端 firmware/exe/{方案商}/{型号}/versions.json 一致）。
 * - 贝盈：机甲 M80/M71 等 keyboardType 即目录名；ES98 在设备表里多为 keyboardType「99」，需按名称识别为 es98。
 * - 华奋达：目录名与 firmware/exe/huafenda/{型号}/ 一致；须在共享 VID/PID 下按 keyboardType / 名称区分。
 */
export function getExeFirmwareBundlePath(equipmentData: any): {
  provider: string;
  model: string;
} | null {
  if (!equipmentData) return null;
  const sol = String(equipmentData.solutionRovider ?? "").trim();
  const pn = String(equipmentData.productName ?? "");
  const dn = String(equipmentData.displayname ?? "");
  const vendorId = Number(equipmentData.vendorId);
  const productId = Number(equipmentData.productId);
  const kt = String(equipmentData.keyboardType ?? "");
  const ktLower = kt.toLowerCase();

  if (sol === "huafenda") {
    const x87v2ByName = /\bX87\s*V2\b/i.test(pn) || /\bX87\s*V2\b/i.test(dn);
    const x87v2ByWiredPid = vendorId === 0x0c45 && productId === 0x80bb;
    if (x87v2ByName || x87v2ByWiredPid) {
      return { provider: "huafenda", model: "x87v2" };
    }

    // X75-Pro（俄文版，PID 0x80d2）：无在线固件，勿误映射到 x75Pro
    if (dn === "X75-Pro" || (vendorId === 0x0c45 && productId === 0x80d2)) {
      return null;
    }

    // 须先于「X75 Pro」判断（名称含 Screen）
    if (
      kt === "75ProTFT" ||
      /\bX75\s*Pro\s+Screen\b/i.test(pn) ||
      /\bX75\s*Pro\s+Screen\b/i.test(dn)
    ) {
      return { provider: "huafenda", model: "x75ProScreen" };
    }

    if (kt === "x75gc" || pn === "X75GC" || dn === "X75GC") {
      return { provider: "huafenda", model: "x75gc" };
    }

    if (kt === "DK108" || pn === "DK108" || dn === "DK108") {
      return { provider: "huafenda", model: "dk108" };
    }

    if (
      kt === "75Pro" ||
      (/\bX75\s*Pro\b/i.test(pn) && !/\bScreen\b/i.test(pn)) ||
      (/\bX75\s*Pro\b/i.test(dn) && !/\bScreen\b/i.test(dn))
    ) {
      return { provider: "huafenda", model: "x75Pro" };
    }

    if (kt === "84" || /\bSMART875\b/i.test(pn) || /\bSMART875\b/i.test(dn)) {
      return { provider: "huafenda", model: "smart875" };
    }

    if (kt === "M98" || pn === "M98" || pn === "MUSE-M98" || dn === "M98") {
      return { provider: "huafenda", model: "m98" };
    }

    if (
      ktLower === "huafenda98" ||
      (vendorId === 0x0c45 && (productId === 0x80b2 || productId === 0xfefa))
    ) {
      return { provider: "huafenda", model: "x98" };
    }

    // 经典 X87：展示名/产品名为严格「X87」，与 X87 V2、SMART875、X75、M98 等区分（见 supportedDevices）
    if (ktLower === "huafenda87" && (pn === "X87" || dn === "X87")) {
      return { provider: "huafenda", model: "x87" };
    }

    return null;
  }

  if (
    sol === "dakai" ||
    dn === "V80" ||
    String(equipmentData.deviceId ?? "") === "v80"
  ) {
    return { provider: "other", model: "v80" };
  }

  const provider =
    sol === "beiying" || sol === "beiyingMachine" ? "beiying" : "";
  if (!provider) return null;

  const ktBeiying = String(equipmentData.keyboardType ?? "").toLowerCase();

  let model = "";
  if (ktBeiying === "m80") model = "m80";
  else if (ktBeiying === "m71") model = "m71";
  else if (ktBeiying === "x75v2") model = "x75v2";
  else if (ktBeiying === "m75") model = "m75";
  else if (/\bES98\b/i.test(pn) || /\bES98\b/i.test(dn)) model = "es98";

  if (!model) return null;
  return { provider, model };
}

/**
 * 将 versions.json 解析结果规范为「固件对象」一维数组。
 * 避免误写成 `[[{...}], {...}]` 时 sort 读到子数组导致抛错、列表为空。
 */
export function normalizeFirmwareJsonList(raw: unknown): any[] {
  if (!Array.isArray(raw)) return [];
  return raw.flatMap((item) =>
    Array.isArray(item) ? item : item != null ? [item] : []
  );
}

const catalogLatestCache = new Map<string, { version: string; at: number }>();
const CATALOG_CACHE_MS = 5 * 60 * 1000;

export async function fetchOnlineCatalogLatestVersion(
  firmwareKey: string
): Promise<string | null> {
  const key = firmwareKey?.trim();
  if (!key) return null;
  const cached = catalogLatestCache.get(key);
  if (cached && Date.now() - cached.at < CATALOG_CACHE_MS)
    return cached.version;
  try {
    const url = getFirmwareFileUrl(key, "versions.json");
    const res = await fetch(url);
    if (!res.ok) return null;
    const parsed = await res.json();
    const firmwares = normalizeFirmwareJsonList(parsed).filter(
      (f: any) => f && typeof f === "object" && typeof f.version === "string"
    );
    if (!firmwares.length) return null;
    firmwares.sort((a: any, b: any) =>
      compareFirmwareVersions(b.version, a.version)
    );
    const latest = String(firmwares[0].version).trim();
    if (!latest) return null;
    catalogLatestCache.set(key, { version: latest, at: Date.now() });
    return latest;
  } catch {
    return null;
  }
}

export async function fetchExeCatalogLatestVersion(bundle: {
  provider: string;
  model: string;
}): Promise<string | null> {
  const cacheKey = `exe:${bundle.provider}/${bundle.model}`;
  const cached = catalogLatestCache.get(cacheKey);
  if (cached && Date.now() - cached.at < CATALOG_CACHE_MS)
    return cached.version;
  try {
    const metaUrl = getFirmwareFileUrl(
      "exe",
      bundle.provider,
      bundle.model,
      "versions.json"
    );
    const res = await fetch(metaUrl);
    if (!res.ok) return null;
    const parsed = await res.json();
    const list = normalizeFirmwareJsonList(parsed).filter(
      (f: any) => f && typeof f === "object" && typeof f.version === "string"
    );
    if (!list.length) return null;
    list.sort((a: any, b: any) =>
      compareFirmwareVersions(String(b.version ?? ""), String(a.version ?? ""))
    );
    const latest = String(list[0].version ?? "").trim();
    if (!latest) return null;
    catalogLatestCache.set(cacheKey, { version: latest, at: Date.now() });
    return latest;
  } catch {
    return null;
  }
}

export type KeyboardFirmwareProbeResult = {
  hasUpdate: boolean;
  latestVersion?: string;
};

export async function probeKeyboardFirmwareUpdate(
  equipmentData: unknown,
  currentVersion: string | null | undefined
): Promise<KeyboardFirmwareProbeResult> {
  if (!equipmentData || typeof equipmentData !== "object") {
    return { hasUpdate: false };
  }
  const eq = equipmentData as Record<string, unknown>;
  const provider = String(eq.solutionRovider ?? "").trim();
  if (!isReliableKeyboardFirmwareVersion(currentVersion, provider)) {
    return { hasUpdate: false };
  }
  const current = String(currentVersion ?? "")
    .replace(/^[Vv]/, "")
    .trim();
  if (!current) return { hasUpdate: false };
  if (provider === "ZHWX" || provider === "SDCX") return { hasUpdate: false };
  if (provider === "huafenda") {
    const bundle = getExeFirmwareBundlePath(eq);
    if (!bundle) return { hasUpdate: false };
    const latest = await fetchExeCatalogLatestVersion(bundle);
    if (!latest) return { hasUpdate: false };
    if (compareFirmwareVersions(latest, current) > 0) {
      return { hasUpdate: true, latestVersion: latest };
    }
    return { hasUpdate: false };
  }
  const firmwareKey = getFirmwareKeyFromDevice(eq);
  if (!firmwareKey) return { hasUpdate: false };
  const latest = await fetchOnlineCatalogLatestVersion(firmwareKey);
  if (!latest) return { hasUpdate: false };
  if (compareFirmwareVersions(latest, current) > 0) {
    return { hasUpdate: true, latestVersion: latest };
  }
  return { hasUpdate: false };
}

export async function probeKeyboardHasFirmwareUpdate(
  equipmentData: unknown,
  currentVersion: string | null | undefined
): Promise<boolean> {
  const result = await probeKeyboardFirmwareUpdate(
    equipmentData,
    currentVersion
  );
  return result.hasUpdate;
}
